new Vue ({
    el: '#campaign-subnav',

    data : {
        active: window.sidenavActive
    },

    methods : {
        toggle : function ( id, $event ) {
            if( this.active !== id ) {
                $event.preventDefault();
                this.active = id;
            }
        },
        activeDropdown : function( id ) {
			if ( id === this.active ) {
				return true;
			}
		},
    }
});

new Vue ({
    el: '#campaign-subnav-mobile',

    data : {
        active : false
    },

    methods : {
        toggle : function ( id, $event) {
            $event.preventDefault();
            this.active = !this.active;
        },
        activeDropdown : function( id ) {
            return this.active;
        }
    }
});